var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeedream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10799_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47241 18.5074C8.67569 14.1012 10.6835 11.4604 11.4646 10.592C7.63789 13.0099 5.09332 17.2378 4.00024 20.3512V21.6654C4.00024 25.2692 7.20102 28.1918 11.1489 28.1918C12.0601 28.1918 12.9321 28.0348 13.7327 27.7495C14.1464 27.6087 14.553 27.4589 14.9542 27.3055C16.0259 26.2499 16.8943 25.0623 17.5897 23.7909C11.8604 26.6475 8.22455 23.8765 8.47241 18.5056V18.5074Z",
    fill: "#1E37FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7468 12.0791C27.3239 11.0199 23.9216 9.25636 20.0593 8.79095C20.407 13.2453 20.168 19.0869 17.5914 23.7927C16.8959 25.0641 16.0276 26.2517 14.9559 27.3073C19.3763 25.6061 22.8784 23.247 25.0521 21.1786C28.3634 18.0259 28.9911 15.0962 29 13.3558C29.0018 12.9136 28.9127 12.4803 28.745 12.0809L28.7468 12.0791Z",
    fill: "#37E1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0376 2.19323C17.4542 0.820192 15.4481 -6.10352e-05 13.2655 -6.10352e-05C11.083 -6.10352e-05 9.14823 0.793445 7.57548 2.1219C5.51593 3.86405 4.14825 6.5263 4.00024 9.54341V20.3494C5.09332 17.2377 7.63789 13.0081 11.4663 10.5901C12.0512 10.221 12.6646 9.89113 13.3101 9.61652C15.523 8.67501 17.8661 8.52166 20.0594 8.78735C19.8008 5.46176 19.2159 2.91362 19.0376 2.18966V2.19323Z",
    fill: "#A569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5634 5.82727C22.0801 5.34047 21.6433 4.90003 21.2938 4.54161C21.0566 4.29197 20.8266 4.04946 20.6055 3.81052C19.6586 2.83513 19.0399 2.19141 19.0399 2.19141C19.2182 2.91359 19.8013 5.4635 20.0616 8.7891C23.9239 9.2545 27.3262 11.018 28.7492 12.0772C27.2139 10.5812 24.6657 7.98311 22.5652 5.82727H22.5634Z",
    fill: "#1E37FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10799_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedream);
export default __webpack_public_path__ + "static/media/seedream.cbc29262a60393d87d856c249776c384.svg";
export { ForwardRef as ReactComponent };